export var preloadDirectory = {
    images:[
        {id:'gfx_loading' , src:'assets/eyeexam/ui/Containers/gfx_loading-2.png', },
        {id:'gfx_loading_bar_con' , src:'assets/eyeexam/ui/Containers/gfx_loading_bar_con.png', },
        {id:'lan_gen_bg' , src: 'assets/eyeexam/ui/Backgrounds/gen_overlay.png', },
        {id:'por_gen_bg', src: 'assets/eyeexam/ui/Backgrounds/gen_overlay.png', },
    ],
    json:[
        {id:'locale_en' , src: 'assets/eyeexam/strings/locale_en.json'},
        {id:'locale_es' , src: 'assets/eyeexam/strings/locale_es.json'},
    ],
    atlas:[
        {id:'gizmo' , spriteSheet: 'assets/eyeexam/animations/gizmo_preloader.png', json: 'assets/eyeexam/animations/gizmo_preloader.json'},
    ]
}

//{id: src: },
export var assetDirectory = {
    images:[
        {id:'gfx_container', src: 'assets/eyeexam/ui/Containers/gfx_container.png',},
        {id:'gfx_container_white', src: 'assets/eyeexam/ui/Containers/gfx_container_white.png',},
        {id:'gfx_pop', src: 'assets/eyeexam/ui/Containers/gfx_pop.png',},
        {id:'gfx_pop2', src: 'assets/eyeexam/ui/Containers/gfx_pop2.png',},
        {id:'gfx_life_off', src: 'assets/eyeexam/ui/Containers/gfx_life_off.png',},
        {id:'gfx_life_on', src: 'assets/eyeexam/ui/Containers/gfx_life_on.png',},
        {id:'gfx_flare_long', src: 'assets/eyeexam/ui/Containers/gfx_flare_long.png',},
        {id:'gfx_flare_star', src: 'assets/eyeexam/ui/Containers/gfx_flare_star.png',},

        {id:'btn_play', src: 'assets/eyeexam/ui/Buttons/btn_play.png',},
        {id:'btn_play_pressed', src: 'assets/eyeexam/ui/Buttons/btn_play_pressed.png',},
        {id:'play_button', src: 'assets/eyeexam/ui/Buttons/btn_return.png',},
        {id:'play_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_return2.png',},
        {id:'mute_button', src: 'assets/eyeexam/ui/Buttons/btn_audio1.png',},
        {id:'mute_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_audio3.png',},
        {id:'unmute_button', src: 'assets/eyeexam/ui/Buttons/btn_audio2.png',},
        {id:'unmute_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_audio4.png',},
        {id:'exit_button', src: 'assets/eyeexam/ui/Buttons/btn_exit.png',},
        {id:'exit_button_pressed',  src: 'assets/eyeexam/ui/Buttons/btn_exit2.png',},
        {id:'pause_button', src: 'assets/eyeexam/ui/Buttons/btn_pause.png',},
        {id:'pause_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_pause2.png',},
        {id:'next_button', src: 'assets/eyeexam/ui/Buttons/btn_prevnext.png',},
        {id:'next_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_prevnext2.png',},
        {id:'check_button', src: 'assets/eyeexam/ui/Buttons/btn_check.png',},
        {id:'check_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_check2.png',},
        {id:'close_button', src: 'assets/eyeexam/ui/Buttons/btn_x.png',},
        {id:'close_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_x2.png',},
        {id:'skip_button', src: 'assets/eyeexam/ui/Buttons/btn_skip.png',},
        {id:'skip_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_skip2.png',},
        {id:'next_question_button', src: 'assets/eyeexam/ui/Buttons/btn_next.png',},
        {id:'next_question_button_pressed', src: 'assets/eyeexam/ui/Buttons/btn_next2.png',},

        {id:'title_glow', src: 'assets/eyeexam/ui/Title Screen/title_glow.png'},
        {id:'title_superbook', src: 'assets/eyeexam/ui/Title Screen/title_superbook.png'},
        {id:'title_eee_gizmo', src: 'assets/eyeexam/ui/Title Screen/title_eee_gizmo.png'},
        {id:'title_eee_eagleeye', src: 'assets/eyeexam/ui/Title Screen/title_eee_eagleeye.png'},
        {id:'title_eee_exam', src: 'assets/eyeexam/ui/Title Screen/title_eee_exam.png'},

        {id:'lan_timer_bar', src: 'assets/eyeexam/ui/Landscape/lan_timer_bar.png',},
        {id:'lan_timer_ctn', src: 'assets/eyeexam/ui/Landscape/lan_timer_ctn.png',},
        {id:'lan_image_holder', src: 'assets/eyeexam/ui/Landscape/lan_image_holder.png',},
        {id:'lan_image_holder_wrong', src: 'assets/eyeexam/ui/Landscape/lan_image_holder_wrong.png',},

        {id: 'por_timer_bar', src: 'assets/eyeexam/ui/Portrait/por_timer_bar.png'},
        {id: 'por_timer_ctn', src: 'assets/eyeexam/ui/Portrait/por_timer_ctn.png'},
        {id: 'por_image_holder', src: 'assets/eyeexam/ui/Portrait/por_image_holder.png'},
        {id: 'por_image_holder_wrong', src: 'assets/eyeexam/ui/Portrait/por_image_holder_wrong.png'},

        {id:'gen_overlay', src: 'assets/eyeexam/ui/Backgrounds/gen_overlay.png'},

        {id: 'htp0', src: 'assets/eyeexam/htp/htp_eee_01.png'},
        {id: 'htp1', src: 'assets/eyeexam/htp/htp_eee_02.png'},
        {id: 'htp2', src: 'assets/eyeexam/htp/htp_eee_03.png'},
        {id: 'htp3', src: 'assets/eyeexam/htp/htp_eee_04.png'},
        {id: 'htp4', src: 'assets/eyeexam/htp/htp_eee_05.png'},
        {id: 'htp5', src: 'assets/eyeexam/htp/htp_eee_06.png'},
    ],
    audio: [
        {id:'bgm', mp3: "assets/eyeexam/bgm/bgm.mp3", ogg: "assets/eyeexam/bgm/bgm.ogg",},
        {id:'correct', mp3:"assets/eyeexam/sfx/correct.mp3", ogg: "assets/eyeexam/sfx/correct.ogg",},
        {id:'wrong', mp3:"assets/eyeexam/sfx/wrong.mp3", ogg: "assets/eyeexam/sfx/wrong.ogg",},
        {id:'ding', mp3:"assets/eyeexam/sfx/ding.mp3", ogg: "assets/eyeexam/sfx/ding.ogg",},
        {id:'tic', mp3:"assets/eyeexam/sfx/tic.mp3", ogg: "assets/eyeexam/sfx/tic.ogg",},
        {id:'toc', mp3:"assets/eyeexam/sfx/toc.mp3", ogg:"assets/eyeexam/sfx/toc.ogg",},
        {id:'button_press', mp3:"assets/eyeexam/sfx/button_sfx.mp3", ogg:"assets/eyeexam/sfx/button_sfx.ogg",},
    ]
}